<script lang="ts">
    import SearchInput from '../../shared/SearchInput.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import { filter } from '../../../stores/filter';
    import { _ } from 'svelte-i18n';
    import TemplateFilter from './TemplateFilter.svelte';
</script>

<TemplateFilter>
    <SearchInput
        placeholder={$_('Search')}
        query={$filter.accounts.query}
        onChange={() => {}}
        onKeyup={query => {
            $filter.accounts.query = query;
        }}
    />
</TemplateFilter>
